import { BaseDto } from '../../base/baseDto.model';

export class CreateRolRequest  extends BaseDto{
}
